export const SHOW_MODAL_NOTIFICATION_GLOBAL         = 'SHOW_MODAL_NOTIFICATION_GLOBAL'
export const DATA_MODAL_NOTIFICATION_GLOBAL         = 'DATA_MODAL_NOTIFICATION_GLOBAL'
export const SHOW_MODAL_TERMS_CONTIDITIONS_GLOBAL   = 'SHOW_MODAL_TERMS_CONTIDITIONS_GLOBAL'